import React, { useState, useEffect } from "react";
import { Fade, Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";
import CommonLoader from "common/CommonLoader"; 
import { PractitionerService } from "utils/PractitionerService";
import pdf_icon from "assets/images/pdf_icon.png";
import image_icon from "assets/images/image_icon.png";
import del_red_icon from "assets/images/del-red-icon.png";

const DocumentInfo = ({
    guid,
    item,
    index,
    extension,
    fileName,
    getDocumentData,
    isLoggedinUser,
    setHasFetched,
    handleRemoveItem,
    hasFetched
}) => {
    const ls_app_val = localStorage.getItem('app_status') || null;
    const [file, setFile] = useState(null);
    const [documentData, setDocumentData] = useState(null);
    const [isPDF, setIsPDF] = useState(false);
    const [url, setUrl] = useState(null);
    const [modal, setModal] = useState(false);
    const [isGlobalLoading, setGlobalLoading] = useState(false);
    const [documentType, setDocumentType] = useState(null);

    const loaderStyles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(255, 255, 255, 0.7)",
            zIndex: 1050,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        loader: {
            textAlign: "center",
        },
    };

    const toggleForm = () => setModal(!modal);
    const fetchData = async () => {
        setGlobalLoading(true);
        try {
            const { data, headers } = await PractitionerService.displayPractionerDocument(
                guid,
                item.id
            );

            const contentType = headers["content-type"] === "application/octet-stream"
                ? "application/pdf"
                : headers["content-type"];
            setIsPDF(contentType === "application/pdf");
            if (contentType === "application/pdf") {
                const blob = new Blob([data], { type: contentType });
                const url = URL.createObjectURL(blob);
                setUrl(url);

            }

            const base64Data = `data:${contentType};base64,${Buffer.from(data).toString("base64")}`;
            setDocumentData(base64Data);
            setFile(data); 
            let docArray = [data, contentType];
            setDocumentType(docArray);
        } catch (error) {
            console.error("Error fetching document:", error);
        } finally {
            setGlobalLoading(false);
        }
    };

    const getPractionerDocument = async () => {
        if (!file) {
            await fetchData();
        }
        toggleForm();
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = documentData;
        let ext = documentType[1].split('/').pop();
        link.download = 'document.' + ext;
        link.target = '_self';
        link.rel = 'noopener noreferrer';
        link.click();
    };

    const handleDocDelete = (id) => {
        swal("Are you sure you want to delete this Document?", {
            buttons: ["Cancel", "Yes"],
        }).then((yesRemove) => {
            if (yesRemove) {
                PractitionerService.deleteDocumentsProfile(guid, id).then((response) => {
                    if (response.status === 204) {
                        setHasFetched((prev) => {
                            return false;
                        });
                        // setTimeout(() => {
                        //     getDocumentData(); // Now it will re-fetch correctly
                        // }, 1000);
                    }
                });
            }
        });
    };

    const getDocIcon = (extension) => {
        switch (extension) {
            case "pdf":
                return pdf_icon;
            default:
                return image_icon;
        }
    };

    return (
        <>
            {isGlobalLoading && (
                <div style={loaderStyles.overlay}>
                    <div style={loaderStyles.loader}>
                        <CommonLoader />
                    </div>
                </div>
            )}

            <li className="nex-icon-list-item align-items-center" key={`docs_${index}`}>
                <div className="card-graphic">
                    <img src={getDocIcon(extension)} alt="" className="no-border" />
                </div>
                <div className="nex-info">
                    <h3 className="card-title d-flex">
                           <div style={{cursor:"pointer"}} onClick={isGlobalLoading ? null : getPractionerDocument}>{item.documentCategory} - {fileName}</div> 
                    </h3>
                    <div className="nex-action">
                        {isLoggedinUser && (
                            <span
                                className="ml-4 nex-del-btn ml-auto"
                                // onClick={() => handleDocDelete(item?.id)}
                                onClick={() => handleRemoveItem(item)}
                            >
                                <img width={18} src={del_red_icon} alt="" />
                            </span>
                        )}
                    </div>
                </div>
            </li>
            <Modal isOpen={modal} toggle={toggleForm} backdrop="static" scrollable centered>
                <ModalHeader toggle={toggleForm}><span style={{ color: "gray" }}>Document Viewer</span></ModalHeader>
                <ModalBody>
                    {documentData &&
                        <>
                            {isPDF
                                ?
                                <div>
                                    <div className="modalbody" style={{ height: "800px" }}>
                                        <embed src={url} style={{ width: "100%", height: "100%" }} />
                                    </div>
                                    <div className="downloadbtn">
                                      <FontAwesomeIcon color="#0087b9" size="xl" style={{ cursor: "pointer" }} icon={faDownload} onClick={handleDownload} />
                                  </div>
                                </div>
                                :
                                <>
                                    <div className="modalbody">
                                        <img src={documentData} alt="document preview" />
                                    </div>
                                    <div className="downloadbtn">
                                        <FontAwesomeIcon color="#0087b9" size="xl" style={{ cursor: "pointer" }} icon={faDownload} onClick={handleDownload} />
                                    </div>
                                </>
                            }
                        </>
                    }
                </ModalBody>
            </Modal >
        </>
    );
};

export default DocumentInfo;